import React from 'react';
import PropTypes from 'prop-types';

import { PROJECT_TYPES } from '@/appConstants';
import { spinner } from '@/assets/images';

import {
  FullHeightWaitingScreen,
  Spinner,
  StandardWaitingScreen,
  StyledIcon,
  Text,
} from './styles';

function WaitingScreen({ resource }) {
  const isProjectMulti = resource === PROJECT_TYPES.multi;

  if (isProjectMulti) {
    return (
      <FullHeightWaitingScreen>
        <Spinner src={spinner} />
      </FullHeightWaitingScreen>
    );
  }

  return (
    <StandardWaitingScreen $isMinfinColors={resource === PROJECT_TYPES.minfin}>
      <StyledIcon name="spinner" width={48} />
      <Text>Зараз ви перейдете на захищену сторінку оплати Portmone.com</Text>
    </StandardWaitingScreen>
  );
}

WaitingScreen.propTypes = {
  resource: PropTypes.oneOf([
    PROJECT_TYPES.minfin,
    PROJECT_TYPES.finance,
    PROJECT_TYPES.multi,
  ]).isRequired,
};
export default WaitingScreen;
